import React from "react";
import { withTranslation } from "react-i18next";
const LabelComponent = props => {
  const requiredLabel = props.t("RequiredField");
  const hasErrors = props.errors && (props.errors.type || props.errors.length > 0);
  if (!props.labelName) {
    return null;
  }
  return /*#__PURE__*/React.createElement("label", {
    className: `form__label ${props.labelClassName ? props.labelClassName : ""}`,
    htmlFor: props.id
  }, /*#__PURE__*/React.createElement("span", {
    className: `form__text ${props.isRequired ? "form__text--required" : ""}`
  }, props.labelName), props.isRequired && /*#__PURE__*/React.createElement("span", {
    className: "form__required-label visually-hidden"
  }, requiredLabel), props.includeError && hasErrors && /*#__PURE__*/React.createElement("span", {
    className: "visually-hidden"
  }, props.errors.message || props.errors[0]));
};
const LabelComponentWithTranslation = withTranslation()(LabelComponent);
export default LabelComponentWithTranslation;